import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { generateRandomColor, getIndicatorsLabels } from '../../utils/helpers';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';


import { 
  Brush,
  CartesianGrid,
  Legend,
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

export default function CustomBarChart({ data, dataKey, big }) {
  const [labels, setLabels] = useState([]);
  const [toolTipId, setToolTipId] = useState('');

  const width = 1000;
  const height = big ? 600 : 300;

  useEffect(() => {
    let lineProperties = [];
    if (dataKey) { // Només mostrarem els valors d'un indicador (el dataKey)
      lineProperties.push({id: dataKey, hide: false, color: '#15afca'})
    } else {
      // Extraim les etiquetes de l'indicador
      const uniqueLabels = getIndicatorsLabels(data);
      // Construim l'array amb els objectes que caracterizen cada linia
      lineProperties = uniqueLabels.map((label) => {
          const color = generateRandomColor();
          return {id: label, hide: false, color}        
      });
    }
    setLabels(lineProperties);
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render



  // Mostra la capsa de Tooltip customizada i només mostra els valors de la línia sobre la que s'ha fet el darrer onMouseEnter
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && toolTipId) {
      const line  = payload.find((item) => item.dataKey === toolTipId);
      return (
        <div style={{backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, paddingTop: 5, paddingBottom: 5, paddingLeft: 10, paddingRight: 10}}>
          <p style={{fontWeight: 'bold'}}>{`${label}`}</p>
          <p style={{color: line.color }}>{translations[toolTipId]}: {`${line.value ||''}`}</p>      
        </div>
      );
    }  
    return null;
  };

  // Mostra o oculta una linea
  const toggleVar = (variable) => {
    const labelsUpdated = labels.map((label)=> {
      if (label.id === variable.dataKey) {
        return {
          ...label,
          hide: !label.hide
        }
      };
      return label
    })
    setLabels(labelsUpdated);
  };

  return (
    <div style={{ width: width, height: height}}>       
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>          
          <CartesianGrid stroke='#ccc' />
          <XAxis dataKey='date' />
          <YAxis />
          {/* ATENCIÓ: Si posam els <Bar /> abans de <CartesianGrid/>, <XAxis/>, <XAxis/>, ...aquests elements es mostren a la gràfica pintats per damunt les barres */}
          {
            labels.map((label) => <Bar type='monotone' stackId={!dataKey ? 'xyz' : null} name={translations[label.id]} dataKey={label.id} fill={label.color} hide={label.hide} key={label.id} onMouseEnter={() => setToolTipId(label.id)} onMouseLeave={() => setToolTipId('')} />)
          }
          <Tooltip cursor={{ fillOpacity:0.5 }} content={<CustomTooltip />}/> {/* L'aspecte del hoover de les barres es controla dins la propietat cursor, per canviar el color es fa amb 'fill:' */}
          <Brush dataKey='date' height={30} stroke='#8884d8'/>
          {!dataKey /* Si només representam un indicador, no mostram la legenda */ && <Legend onClick={toggleVar} verticalAlign='bottom' wrapperStyle={{ position: 'relative', top: -20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, width: '100%'}} />}
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

// Indica i controla els props que se han de passar al component
CustomBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  dataKey: PropTypes.string,
  big: PropTypes.bool
};
